import { render, staticRenderFns } from "./SideBarMenu.vue?vue&type=template&id=30f23128&scoped=true"
import script from "./SideBarMenu.vue?vue&type=script&lang=js"
export * from "./SideBarMenu.vue?vue&type=script&lang=js"
import style0 from "./SideBarMenu.vue?vue&type=style&index=0&id=30f23128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f23128",
  null
  
)

export default component.exports